import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ClientService } from 'tnx-admin-service/client-management/services';
import { ComponentContextService, DataFormBase, DropdownControlSchema, EventData, FormSchemaBase, SwitchControlSchema, TableSchema, TextAreaControlSchema, TextControlSchema } from 'tnx-shared';
import {
    ClientGrantType, ClientProtocolDatasource, ClientGrantTypeEnum, ClientProtocolEnum,
    DefaultAllowedScope, EmailClaimType, EndpointClaimType, GuidClaimType, IsExternalClientClaim, IsInternalClientClaim, OrgIdentityClaimType, SharedSecretType
} from 'tnx-admin-service/client-management/models';

@Component({
    selector: 'client-management-form',
    templateUrl: './client-management-form.component.html',
    styleUrls: ['./client-management-form.component.scss'],
    providers: [ComponentContextService]
})
export class ClientManagementFormComponent extends DataFormBase implements OnInit {
    @ViewChild('clientSecretRowButton', { static: true }) clientSecretRowButton: TemplateRef<any>;

    limit = 1000;
    suggestions = [];
    domains = [];
    endPointList: any;

    attachFiles = [];
    attachFileCols: any;

    attachKey = [];
    attachKeyColumn: any;

    listSecretKey = [];
    clientSecretIsDelete = [];

    endPointIsDelete = [];

    email = '';
    emailId = '0';

    orgIdentity = '';
    orgIdentityId = '0';

    hasGuidClaim = false;
    idPopup: any;

    id = 0;
    // @Input    () popupSizeInput    : any;
    // TODO: Tạm sử dụng cho đến khi chuyển sang core mới 4.2.0+
    useOldApi = true;

    constructor(
        protected _clientService: ClientService,
        protected _injector: Injector,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.isBaseModel = false;
        this.setting.baseService = this._clientService;
        this.model.data.requireClientSecret = true;
        this.parentSetting.popupSize.width = 900;
        this.parentSetting.popupSize.height = 800;
        if (this._router.url.indexOf('userpermission') != -1)
            this.model.data.guid = this.model.data.id;

        this.setting.schema = <FormSchemaBase[]>[
            new DropdownControlSchema({
                field: 'clientProtocol',
                label: this._translateService.instant('Hình thức xác thực'),
                mdWidth: 12,
                required: true,
                multiple: false,
                dataSource: ClientProtocolDatasource,
                defaultIndex: 0,
            }),
            // new SwitchControlSchema({
            //     field: 'requireClientSecret',
            //     label: this._translateService.instant('Y/c bắt buộc mã bí mật'),
            //     mdWidth: 12,
            //     required: true
            // }),
            new SwitchControlSchema({
                field: 'internalClient',
                label: this._translateService.instant('Ứng dụng trong hệ thống'),
                mdWidth: 12,
                defaultValue: false,
                disabled: this.model.data && this.model.data.id,
            }),
            new TextControlSchema({
                field: 'clientName',
                label: this._translateService.instant('Tên ứng dụng'),
                mdWidth: 12,
                required: true
            }),
            new TextControlSchema({
                field: 'clientId',
                label: this._translateService.instant('Mã ứng dụng'),
                mdWidth: 12,
                required: true
            }),
            new TableSchema({
                field: 'clientSecrets',
                label: this._translateService.instant('Mã bí mật'),
                mdWidth: 12,
                onAdded: (evt: EventData) => {
                    console.log(evt.currentNode);
                },
                rowButtonTemplate: this.clientSecretRowButton,
                rowTemplate: [
                    new TextControlSchema({
                        field: 'value',
                        label: 'Secret Key',
                        disabled: true,
                    }),
                    new TextControlSchema({
                        field: 'type',
                        label: 'type',
                        hidden: true,
                        defaultValue: SharedSecretType
                    }),
                    new TextControlSchema({
                        field: 'tempId',
                        label: 'tempId',
                        hidden: true,
                    })
                ]
            }),
            new TableSchema({
                field: 'endpoints',
                label: this._translateService.instant('Uri Redirect'),
                mdWidth: 12,
                onDeleting: (evt: EventData) => {
                    console.log(evt.sourceNode.value);
                    this.endPointIsDelete.push(evt.sourceNode.value);
                },
                rowTemplate: [
                    new TextControlSchema({
                        field: 'value',
                        label: 'Endpoint'
                    }),
                    new TextControlSchema({
                        field: 'type',
                        label: 'type',
                        defaultValue: EndpointClaimType,
                        hidden: true,
                    }),
                ]
            }),
            new TableSchema({
                field: 'allowedCorsOrigins',
                label: this._translateService.instant('Cors Origin'),
                showEdit: false,
                mdWidth: 12,
                initRowCount: 0,
                rowTemplate: [
                    new TextControlSchema({
                        field: 'origin',
                        label: 'Origin'
                    })
                ]
            }),
            new TextControlSchema({
                field: 'accessTokenLifetime',
                label: this._translateService.instant('Access token hết hạn sau (s)'),
                mdWidth: 12
            }),
            new TextControlSchema({
                field: 'orgIdentityClient',
                label: this._translateService.instant('Mã đơn vị'),
                mdWidth: 12
            }),
            new TextControlSchema({
                field: 'emailClient',
                label: this._translateService.instant('Email liên hệ'),
                mdWidth: 12
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: this._translateService.instant('Mô tả'),
                mdWidth: 12
            }),
        ];
        // this.attachFileCols = [
        //     { field: 'stt', header: this._translateService.instant('STT'), width: '10%', visible: true, dataType: 'stt' },
        //     { field: 'name', header: this._translateService.instant('Đường dẫn'), width: '80%', visible: true, dataType: 'name' },
        // ];
        //
        // this.attachKeyColumn = [
        //     { field: 'stt', header: this._translateService.instant('STT'), width: '10%', visible: true, dataType: 'stt' },
        //     { field: 'secretKey', header: this._translateService.instant('Secret Key'), width: '80%', visible: true, dataType: 'clientSecret' },
        // ];
        super.ngOnInit();
    }

    async getDetailCustom() {
        if (this.model.data.guid) return this._clientService.getDetailByGuid(this.model.data.guid);
        return this._clientService.getDetail(this.model.data.id);
    }

    async onFormInitialized(data) {
        if (!this.model.data.id) {
            this.model.data.internalClient = false;
            this.model.data.accessTokenLifetime = 8640000;
            this.email = '';
            this.emailId = '0';

            this.orgIdentity = '';
            this.orgIdentityId = '0';
        }
    }

    async modifyDetailData(data) {
        if (data.issuedDate) {
            data.issuedDate = new Date(data.issuedDate);
        }

        if (data.allowedGrantTypes?.length > 0) {
            data.clientProtocol = ClientManagementFormComponent.getClientProtocol(data.allowedGrantTypes);
        }

        if (data.claims?.length > 0) {
            data.claims.forEach(element => {
                if (element.type === EndpointClaimType) {
                    data.endpoints = [];
                    data.endpoints.push({ tempId: this._commonService.guid(), type: element.type, value: element.value, id: element.id });
                }
                if (element.type === EmailClaimType) {
                    this.email = element.value;
                    this.emailId = element.id;
                }
                if (element.type === OrgIdentityClaimType) {
                    this.orgIdentity = element.value;
                    this.orgIdentityId = element.id;
                }
                if (element.type == IsInternalClientClaim)
                    data.internalClient = element.value == 'true';
                if (element.type == GuidClaimType)
                    this.hasGuidClaim = true;
            });
        }

        // if (data.clientSecrets?.length > 0) {
        //     data.clientSecrets.forEach(element => {
        //         this.attachKey.push({ tempId: this._commonService.guid(), value: element.value, id: element.id, isAddNew: false });
        //     });
        // }
    }

    onBeforeSave() {
        const domainItems: string[] = [];
        // map lại dữ liệu cho các trường này vì chỉ cần chuyển về giống với dto model
        for (const allowedCors of this.model.data.allowedCorsOrigins) {
            if (!allowedCors.origin) continue;
            domainItems.push(allowedCors.origin);
        }
        const clientSecretItems = [];
        for (const secret of this.model.data.clientSecrets) {
            if (!secret.value) continue;
            clientSecretItems.push({ value: secret.value, id: secret.id, type: secret.type });
        }
        this.model.data.clientSecrets = clientSecretItems;
        // this.model.data.clientSecrets = this.model.data.clientSecrets.map(x => {x.value});
        this.model.data.allowedCorsOrigins = domainItems;
        this.model.data.postLogoutRedirectUris = domainItems;
        this.model.data.redirectUris = domainItems;
        this.model.data.allowAccessTokensViaBrowser = true;
        this.model.data.allowedScopes = DefaultAllowedScope;
        this.model.data.clientSecretIsDelete = this.clientSecretIsDelete;
        this.model.data.endpointIsDelete = this.endPointIsDelete;
        this.model.data.clientType = this.model.data.clientProtocol;
        this.model.data.identityTokenLifetime = this.model.data.accessTokenLifetime;
        this.model.data.claims = this.model.data.endpoints;
        this.model.data.allowedGrantTypes = ClientManagementFormComponent.getClientGrantType(this.model.data.clientProtocol);
        if (this.email == null) {
            this.email = '';
        }

        if (this.orgIdentity == null) {
            this.orgIdentity = '';
        }

        this.model.data.clientClaims = [
            { type: EmailClaimType, value: this.email, id: this.emailId },
            { type: OrgIdentityClaimType, value: this.orgIdentity, id: this.orgIdentityId },
        ];
        // Nếu là client ngoài hệ thống thì phải thêm client này vào để check Api => Thêm vào ClientClaim
        // if (this.model.data.externalClient) {
        const isInternal = !!this.model.data.internalClient;
        this.model.data.clientClaims.push({
            type: isInternal ? IsInternalClientClaim : IsExternalClientClaim,
            value: true,
        });
        // }

        if (!this.hasGuidClaim) {
            const guidClaimValue = this._commonService.guid();
            this.model.data.clientClaims.push({
                type: GuidClaimType,
                value: guidClaimValue
            });
        }

        // implicit flow
        if (this.model.data.clientProtocol == ClientProtocolEnum.IMPLICIT) {
            if (!this.model.data.redirectUris) {
                this.model.data.redirectUris = [];
            }
            this.model.data.redirectUris.push(`${domainItems}/silent-refresh.html`);
        }

        // let grantType = this.model.data.clientProtocol === '1' ? ['implicit'] : ['client_credentials'];
        // this.model.data.protocolType = 'oidc';
        // this.model.data.frontChannelLogoutUri = '';
        // this.model.data.frontChannelLogoutSessionRequired = true;
        // this.model.data.backChannelLogoutUri = '';
        // this.model.data.backChannelLogoutSessionRequired = true;
        // this.model.data.enableLocalLogin = true;
        // this.model.data.identityProviderRestrictionsItems = '';
        // this.model.data.accessTokenType = 0;
        // this.model.data.authorizationCodeLifetime = 300;
        // this.model.data.absoluteRefreshTokenLifetime = 25920000;
        // this.model.data.slidingRefreshTokenLifetime = 12960000;
        // this.model.data.refreshTokenUsage = 0;
        // this.model.data.refreshTokenExpiration = 0;
        // this.model.data.includeJwtId = true;
        // this.model.data.alwaysSendClientClaims = true;
        // this.model.data.alwaysIncludeUserClaimsInIdToken = true;
        // this.model.data.pairWiseSubjectSalt = '';
        // this.model.data.clientUri = '';
        // this.model.data.logoUri = '';
        // this.model.data.requirePkce = false;
        // this.model.data.allowPlainTextPkce = false;
        // this.model.data.allowOfflineAccess = true;
        // this.model.data.allowAccessTokensViaBrowser = true;
        // this.model.data.frontChannelLogoutSessionRequired = false;
        // this.model.data.backChannelLogoutSessionRequired = false;
        // this.model.data.enableLocalLogin = false;
        // this.model.data.updateAccessTokenClaimsOnRefresh = false;
        // this.model.data.includeJwtId = false;
        // this.model.data.alwaysSendClientClaims = false;
        // this.model.data.alwaysIncludeUserClaimsInIdToken = false;
        // this.model.data.requireConsent = false;
        // this.model.data.allowRememberConsent = false;
        // this.model.data.type = 'SharedSecret';
        // this.model.data.HashType = 'Sha256';
    }

    private static getClientProtocol(clientGrantTypes: ClientGrantType[]) {
        switch (clientGrantTypes[0].grantType) {
            case ClientGrantTypeEnum.IMPLICIT:
                return ClientProtocolEnum.IMPLICIT;
            case ClientGrantTypeEnum.HYBRID:
                return ClientProtocolEnum.HYBRID;
            case ClientGrantTypeEnum.AUTHORIZATION_CODE:
                return ClientProtocolEnum.AUTHORIZATION_CODE;
            case ClientGrantTypeEnum.CLIENT_CREDENTIALS:
                return ClientProtocolEnum.CLIENT_CREDENTIAL;
            case ClientGrantTypeEnum.RESOURCE_OWNER_PASSWORD:
                return ClientProtocolEnum.RESOURCE_OWNER_PASSWORD;
            case ClientGrantTypeEnum.DEVICE_FLOW:
                return ClientProtocolEnum.DEVICE_FLOW;
        }
    }

    private static getClientGrantType(clientProtocol: ClientProtocolEnum) {
        switch (clientProtocol) {
            case ClientProtocolEnum.AUTHORIZATION_CODE:
                return [ClientGrantTypeEnum.AUTHORIZATION_CODE];
            case ClientProtocolEnum.IMPLICIT:
                return [ClientGrantTypeEnum.IMPLICIT];
            case ClientProtocolEnum.HYBRID:
                return [ClientGrantTypeEnum.HYBRID];
            case ClientProtocolEnum.CLIENT_CREDENTIAL:
                return [ClientGrantTypeEnum.CLIENT_CREDENTIALS];
            case ClientProtocolEnum.RESOURCE_OWNER_PASSWORD:
                return [ClientGrantTypeEnum.RESOURCE_OWNER_PASSWORD];
            case ClientProtocolEnum.DEVICE_FLOW:
                return [ClientGrantTypeEnum.DEVICE_FLOW];
        }
    }

    generateKey(event, action: string, rowData: any) {
        // switch (col.field) {
        //     case 'clientSecret': {
        // this.listSecretKey.push({ value: this.attachKey[rowData].value });
        // break;
        // }
        // case 'clientProtocol': {
        //     break;
        // }
        // default: {
        //     // this.suggestions = [event.query];
        // }
        // }
        if (action === 'generateSecretKey') {
            rowData.value = this._commonService.guid();
        }
        else {
            this.copyMessage(rowData.value);
            this._notifierService.showSuccess('Đã copy');
        }
    }

    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    onAddDocument() {
        this.attachFiles.push({ tempId: this._commonService.guid(), type: EndpointClaimType, value: '' });
    }

    deleteDocumentRow(data) {
        // this._notifierService.genericShow(
        //     'Bạn có chắc chắn muốn xóa End Point này?',
        //     'Xác nhận xóa',
        //     '',
        //     true,
        //     this._translateService.instant('CONFIRM.ACCEPT_LABEL'),
        //     '',
        //     this._translateService.instant('CONFIRM.REJECT_LABEL'),
        //     '',
        //     () => {
        //         // this.listSecretKeyIsDelete.push({ value: data.value, clientSecretId: data.id });
        //         // this.attachKey = this.attachKey.filter(x => (data.id > 0 && x.id != data.id) || x.tempId !== data.tempId);
        //     },
        //     null,
        //     NotifierType.CONFIRM
        // );
        // this.attachFiles = this.attachFiles.filter(x => (data.id > 0 && x.id != data.id) || x.tempId !== data.tempId);
        this.endPointIsDelete.push({ type: data.type, value: data.value, clientClaimId: data.id });
    }

    onAddSecretKey() {
        this.attachKey.push({ tempId: this._commonService.guid(), value: '', id: '', isAddNew: true });
    }

    deleteSecretKey(rowData, index, control, path) {
        // if (this.idPopup) {
        //     this._notifierService.genericShow(
        //         'Bạn có chắc chắn muốn xóa secret key này?',
        //         'Xác nhận xóa',
        //         '',
        //         true,
        //         this._translateService.instant('CONFIRM.ACCEPT_LABEL'),
        //         '',
        //         this._translateService.instant('CONFIRM.REJECT_LABEL'),
        //         '',
        //         () => {
        //             this.clientSecretIsDelete.push({ value: data.value, clientSecretId: data.id });
        //             this.attachKey = this.attachKey.filter(x => (data.id > 0 && x.id != data.id) || x.tempId !== data.tempId);
        //         },
        //         null,
        //         NotifierType.CONFIRM
        //     );
        // }
        // else {
        // }
        // = this.attachKey.filter(x => (data.id > 0 && x.id != data.id) || x.tempId !== data.tempId);
        // console.log(this.model.data.clientSecrets);
        // this.removeAllElements(this.listSecretKey, value);
        this.crudForm.deleteRow(index, control, path);
        this.clientSecretIsDelete.push({ value: rowData.value, clientSecretId: rowData.id });
    }

    removeAllElements(array, elem) {
        array.splice(elem, 1);
    }
}
